import Node from './Node';

/*
 * @class VideoBoxBigPlay
 * @mixes $w.Node
 * @viewername wysiwyg.viewer.components.MediaPlayerOverlayControls
 * @definitionId wysiwyg.viewer.components.MediaPlayerOverlayControls
 * @tagname videoBoxBigPlay
 */
class VideoBoxBigPlay extends Node {}

export default VideoBoxBigPlay;